import styled from "styled-components";

export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${(props) => props.height}px;
  overflow: hidden;
  border-radius: 8px;
  background: #000;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: ${(props) => (props.$hasVideoUrl ? "pointer" : "default")};
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  pointer-events: ${(props) => (props.$hasVideoUrl ? "auto" : "none")};

  /* NOVO: CSS containment za bolje performanse */
  contain: layout style paint;
  will-change: transform;

  &:hover .small {
    transform: ${(props) =>
      props.$hasVideoUrl ? "rotate(0deg)" : "rotate(-15deg)"};
  }
`;

export const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${(props) => (props.$loaded ? "1" : "0")};
  visibility: ${(props) => (props.$loaded ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.$loaded ? "auto" : "none")};
  transition: opacity 0.4s ease;
  z-index: 1;
  border-radius: 8px;

  /* NOVO: Optimizacije */
  content-visibility: auto;
  will-change: opacity;
  transform: translateZ(0);
  backface-visibility: hidden;
`;

export const ThumbnailImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${(props) => (props.$loaded ? "0" : "1")};
  visibility: ${(props) => (props.$loaded ? "hidden" : "visible")};
  filter: ${(props) => (props.$blur ? "blur(8px)" : "none")};
  transform: ${(props) => (props.$blur ? "scale(1.1)" : "scale(1)")};
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 12px;

  /* NOVO: Optimizacije */
  content-visibility: auto;
  will-change: opacity, transform;
`;

export const ThumbnailImageSmall = styled.img`
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 25;
  border-radius: 6px;
  object-fit: cover;
  transition: transform 0.3s ease;
  width: 64px;
  height: 80px;
  transform: rotate(-6.016deg);

  /* NOVO: Optimizacije */
  will-change: transform;
  backface-visibility: hidden;

  @media (max-width: 768px) {
    width: 45px;
    height: 56px;
    border-radius: 4px;
  }
`;

export const LoadingSpinner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: ${(props) => (props.$show ? "flex" : "none")};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 5;
  height: 100%;
  width: 100%;
  border-radius: 12px;

  /* NOVO: GPU acceleration */
  will-change: opacity;

  l-line-spinner {
    --spinner-color: white;
  }
`;

export const LoadingSpinnerBlur = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: ${(props) => (props.$show ? "flex" : "none")};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 5;
  height: 100%;
  width: 100%;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(23.1px);
  gap: 12px;

  /* NOVO: Optimizacija blur-a */
  will-change: backdrop-filter;
  transform: translate(-50%, -50%) translateZ(0);

  l-line-spinner {
    --spinner-color: white;
  }
`;

export const CollectionThumbnail = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 12px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${(props) => (props.$loaded ? "0" : "1")};
  visibility: ${(props) => (props.$loaded ? "hidden" : "visible")};
  filter: ${(props) => (props.$blur ? "blur(8px)" : "none")};
  transform: ${(props) => (props.$blur ? "scale(1.1)" : "scale(1)")};
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);

  /* NOVO: Optimizacije */
  content-visibility: auto;
  will-change: opacity, transform;
  backface-visibility: hidden;
`;

export const CollectionContainer = styled.div`
  width: 100%;
  max-width: 338px;
  height: auto;
  height: 400px;
  border-radius: 12px;
  cursor: ${(props) => (props.$inProgress ? "not-allowed" : "pointer")};
  position: relative;
  overflow: hidden;
  transition: opacity 0.3s ease;

  /* NOVO: CSS containment */
  contain: layout style paint;
  will-change: transform;
`;

export const RunningText = styled.div`
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .running-title {
    color: #fff;
    text-align: center;
    font-family: DM Sans;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -0.09px;
  }

  .running-message {
    color: #fff;
    text-align: center;
    font-family: DM Sans;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: -0.07px;
  }
`;

export const Rating = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 6px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 3;
  backdrop-filter: blur(4px);

  /* NOVO: Optimizacija */
  will-change: transform;
  transform: translateZ(0);
`;

export const GenerateButton = styled.button`
  position: absolute;
  bottom: ${(props) => (props.$show ? "20px" : "-60px")};
  left: 50%;
  transform: translateX(-50%);
  color: #333;
  border: none;
  cursor: pointer;
  opacity: ${(props) => (props.$show ? "1" : "0")};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 20;

  border-radius: 100px;
  background: #fff;

  display: flex;
  padding: 10px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  color: #0f2c32;
  font-family: DM Sans;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.08px;

  /* NOVO: Optimizacija */
  will-change: transform, opacity;
  backface-visibility: hidden;

  &:hover {
    transform: translateX(-50%) scale(1.05);
  }

  &:active {
    transform: translateX(-50%) scale(0.98);
  }
`;

export const VideoFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  color: white;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 61.05%,
    rgba(0, 0, 0, 0.64) 100%
  );
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 10;

  /* NOVO: Optimizacija */
  will-change: opacity, transform;

  & > * {
    opacity: ${(props) => (props.$hideContent ? "0" : "1")};
    transform: translateY(${(props) => (props.$hideContent ? "20px" : "0")});
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

export const ModelName = styled.div`
  color: #fff;
  text-align: center;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.07px;
  white-space: nowrap;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Username = styled.div`
  color: #fff;
  text-align: center;
  font-family: DM Sans;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: -0.05px;
  white-space: nowrap;
  opacity: 0.5;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const BadgeContainer = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
`;

export const Badge = styled.span`
  border-radius: 100px;
  background: ${(props) => {
    if (props.$variant === "Free Trial") {
      return "linear-gradient(0deg, #E6474B -47.22%, #FBA866 100%)";
    } else if (props.$variant === "Popular") {
      return "linear-gradient(0deg, #66033C -47.22%, #D74A96 100%)";
    } else if (props.$variant === "New") {
      return "linear-gradient(0deg, #033D66 -47.22%, #00A3A3 100%)";
    } else if (props.$variant === "Trending") {
      return "linear-gradient(180deg, #1F6BAF 0%, #0D1C33 100%)";
    }
    return "linear-gradient(0deg, #66033C -47.22%, #D74A96 100%)";
  }};

  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  color: #fafafa;
  font-family: DM Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;

  /* NOVO: Optimizacija */
  will-change: transform;
  backface-visibility: hidden;
`;
